// eslint-disable-next-line import/prefer-default-export
export enum OpportunityStatusType {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  SIGNED = 'SIGNED',
  NOT_SIGNED = 'NOT SIGNED',
  TENANTED = 'Tenanted',
}
